/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ComparisonsControllerListByRootFileIdQueryResponse, ComparisonsControllerListByRootFileIdQueryParams, ComparisonsControllerListByRootFileId401, ComparisonsControllerListByRootFileId403 } from "../../models/comparisonsController/ComparisonsControllerListByRootFileId";

function getComparisonsControllerListByRootFileIdUrl() {
  const res = { method: 'GET', url: `/api/v1/comparisons` as const }  
  return res
}

/**
 * @description Returns comparisons for rootFileId, one per (scopeIdA, scopeIdB) when multiple runs exist (newest kept), ordered by createdAt descending.
 * @summary List comparisons by root file
 * {@link /api/v1/comparisons}
 */
export async function comparisonsControllerListByRootFileId(params: ComparisonsControllerListByRootFileIdQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ComparisonsControllerListByRootFileIdQueryResponse, ResponseErrorConfig<ComparisonsControllerListByRootFileId401 | ComparisonsControllerListByRootFileId403>, unknown>({ method : "GET", url : getComparisonsControllerListByRootFileIdUrl().url.toString(), params, ... requestConfig })  
  return res.data
}